/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */

import classNames from "classnames";
import React from "react";

export type PageLinkType = {
  displayPageNumber: number;
  page: number;
  ariaItemLabel: string;
  index: number;
  onClick: (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    numberDisplayed: number
  ) => void;
  showEllipsisPrefix?: boolean;
  showEllipsisSuffix?: boolean;
};

const Ellipsis = (): React.ReactElement => (
  <span className="spark-pagination__ellipsis">...</span>
);

const PageLink = ({
  displayPageNumber,
  page,
  ariaItemLabel,
  index,
  onClick,
  showEllipsisPrefix,
  showEllipsisSuffix,
}: PageLinkType): React.ReactElement => {
  return (
    <>
      {showEllipsisPrefix && <Ellipsis />}
      <a
        className={classNames("spark-pagination__item", {
          "spark-pagination__item--active": displayPageNumber === page,
        })}
        aria-current={displayPageNumber === page ? true : undefined}
        aria-label={`${ariaItemLabel} ${displayPageNumber}`}
        key={`index${displayPageNumber}${index}`}
        onClick={(e): void => onClick?.(e, displayPageNumber)}
        href={"#"}
      >
        {displayPageNumber}
      </a>
      {showEllipsisSuffix && <Ellipsis />}
    </>
  );
};

export default PageLink;
